const labels =  {
    LBL_LOGIN_TITLE: 'Connexion au portail RGPD',
    LBL_USERNAME: 'Identifiant',
    LBL_PASSWORD: 'Mot de passe',
    LBL_RESET_PASSWORD_TITLE: 'Mot de passe oublié ?',
    LBL_RESET_PASSWORD_TEXT: 'Remplissez le formulaire ci-dessous et nous vous enverrons par email les informations nécessaires pour accéder à votre compte.',
    LBL_EMAIL_ADDRESS: 'Adresse email',
    LBL_GOTO_LOGIN_PAGE: 'Aller à la page de connexion',
    LBL_EXPORT: 'Exporter mes données',
    LBL_FORGET_ME: 'Supprimer mes données',
    LBL_SAVE: 'Enregistrer',
    LBL_CONSENTS_MANAGER: 'Gestion des consentements',
    LBL_PERSONNEL_CONSENTS_DATA: 'Données personnelles et consentements',
    LBL_FORGET_ME_CONFIRM: 'Oui, anonymiser mes données !',
    LBL_CANCEL: 'Annuler',
    LBL_REQUEST_ACCESS_TITLE: "Demande d'accès",

    LBL_LOGIN_ERROR: 'Identifiant ou mot de passe invalide',

    LBL_RESET_PASSWORD_DONE: 'Les paramètres de connexion ont bien été envoyés à votre email',
    LBL_SAVE_DONE: 'Les modifications ont été effectuées',
    LBL_EXPORT_DONE: "L'export des données est en cours, vous allez recevoir le lien de téléchargement par email",
    LBL_REQUEST_ACCESS_DONE: 'Votre demande a bien été prise en compte',
    LBL_ARE_YOU_SURE: 'Êtes-vous certain ?',
    LBL_FORGET_ME_TEXT: 'Toutes vos données seront remplacées par des données anonymes !',
    LBL_DOWNLOAD_IN_PROGRESS: 'Téléchargement en cours...',
    LBL_PORTAL_ACCESS_REFUSED: 'Accès au portail refusé !',
    LBL_EMAIL_IS_NOT_REGISTERED: "L'email n'est pas enregistré !",
    LBL_SYSTEM_ERROR: 'Opération non autorisée',
    LBL_CREDENTIALS_ALREADY_EXIST: 'Email déjà enregistré',

    LBL_GDPR_PORTAL: 'Portail RGPD',
    LBL_LOGIN_PAGE: 'Connexion',
    LBL_PASSWORD_RECOVERY_PAGE: 'Réinitialiser le mot de passe',
    LBL_HOME_PAGE: "Page d'accueil",
    LBL_DOWNLOAD_PAGE: 'Téléchargement des données',
    LBL_REQUEST_ACCESS_PAGE: "Demande d'accès au portail",
}

export default labels


// WEBPACK FOOTER //
// ./src/languages/fr_fr.js